module.exports = __webpack_public_path__ + "static/media/bg_top_01.b24e27f6.png";